<div class="login-right glass-effect">

  <a mat-button [routerLink]="['/auth']">Retour au Login</a>
  <h2 class="login-title">{{ 'title.reset-password' | translate }}</h2>
  <form [formGroup]="loginForm" (ngSubmit)="setPassword()">


    <!-- Champ mot de passe -->
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Password</mat-label>
      <input matInput type="password" formControlName="password" required (input)="checkPasswordCriteria()" />
      <mat-icon matSuffix>lock</mat-icon>
      <mat-error *ngIf="loginForm.get('password')?.touched && loginForm.get('password')?.invalid">
        <span *ngIf="loginForm.get('password')?.errors?.['required']">
          This field is mandatory.
        </span>
      </mat-error>
    </mat-form-field>

    <!-- Champ confirmation -->
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Confirm Password</mat-label>
      <input matInput type="password" formControlName="confirmPassword" required />
      <mat-icon matSuffix>lock</mat-icon>
      <mat-error *ngIf="loginForm.get('confirmPassword')?.touched && loginForm.get('confirmPassword')?.invalid">
        <span *ngIf="loginForm.get('confirmPassword')?.errors?.['required']">
          This field is mandatory.
        </span>
      </mat-error>
    </mat-form-field>

    <!-- Critères du mot de passe -->
    <div class="password-criteria">
      <ul>
        <li [class.valid]="passwordCriteria.length" [class.invalid]="reachedCriteria.length && !passwordCriteria.length">
          Le mot de passe doit contenir au moins 8 caractères.
        </li>
        <li [class.valid]="passwordCriteria.uppercase" [class.invalid]="reachedCriteria.uppercase && !passwordCriteria.uppercase">
          Le mot de passe doit contenir au moins une lettre majuscule (A-Z).
        </li>
        <li [class.valid]="passwordCriteria.lowercase" [class.invalid]="reachedCriteria.lowercase && !passwordCriteria.lowercase">
          Le mot de passe doit contenir au moins une lettre minuscule (a-z).
        </li>
        <li [class.valid]="passwordCriteria.digit" [class.invalid]="reachedCriteria.digit && !passwordCriteria.digit">
          Le mot de passe doit contenir au moins un chiffre (0-9).
        </li>
        <li [class.valid]="passwordCriteria.noSpaces" [class.invalid]="reachedCriteria.noSpaces && !passwordCriteria.noSpaces">
          Le mot de passe ne doit pas contenir d'espaces.
        </li>
      </ul>
    </div>

    <div>
      <lib-button *ngIf="!message" text="{{ 'login.change_password' | translate }}" type="submit">
      </lib-button>

      <lib-button *ngIf="success" text="{{ 'login.home' | translate }}" (click)="onClickHome()">
      </lib-button>

      @if(message){
      <p class="success-text">{{ message | translate }}</p>
      }

      @if(error){
      <p class="error-text">
        {{ error | translate }}
      </p>
      }
      <!-- <ng-container *ngIf="!message">
        <a href="" class="login-forgot-password" (click)="onLogin($event)">
          {{ 'login.login' | translate }}
        </a>
      </ng-container> -->
    </div>
  </form>
</div>
